// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// Promise = chunk loading, 0 = chunk loaded
var installedChunks = {
	"main": 0
};

var deferredModules = [
	["./web/index.web.tsx","defaultVendors-node_modules_babel_runtime_helpers_classCallCheck_js-node_modules_babel_runtim-44975f","defaultVendors-node_modules_error-stack-parser_error-stack-parser_js-node_modules_fbjs_lib_in-5047db","defaultVendors-node_modules_react-dom_cjs_react-dom_development_js","defaultVendors-node_modules_react-dom_index_js-node_modules_react-i18next_dist_es_index_js-no-71d975","defaultVendors-node_modules_react-native-community_async-storage_lib_module_index_js-node_mod-1c1ebb","defaultVendors-node_modules_react-native-eva-icons_icons_Email_js-node_modules_react-native-e-3bcffe","defaultVendors-node_modules_react-native-eva-icons_icons_PlayCircle_js-node_modules_react-nat-eb9cd8","defaultVendors-node_modules_react-native-eva-icons_index_js","defaultVendors-node_modules_react-native-iphone-x-helper_index_js-node_modules_react-native-s-4e7c8f","defaultVendors-node_modules_react-native-svg_lib_module_index_js","defaultVendors-node_modules_react-native-web_dist_exports_AccessibilityInfo_index_js-node_mod-de3e5c","defaultVendors-node_modules_react-native-web_dist_exports_Easing_index_js-node_modules_react--b6dc57","defaultVendors-node_modules_react-native-web_dist_index_js-node_modules_react-native-web_dist-7380ad","defaultVendors-node_modules_react-native-web_dist_vendor_hash_index_js-node_modules_react-nat-e33bcc","defaultVendors-node_modules_react-native-web_dist_vendor_react-native_VirtualizedSectionList_-1bc1c6","defaultVendors-node_modules_react-navigation_bottom-tabs_lib_module_index_js","defaultVendors-node_modules_react-navigation_native_lib_module_index_js-node_modules_react-na-502f43","defaultVendors-node_modules_react-redux_es_index_js","defaultVendors-node_modules_react_index_js","defaultVendors-node_modules_reduxjs_toolkit_dist_redux-toolkit_esm_js-node_modules_reactotron-768b05","defaultVendors-node_modules_scheduler_index_js-node_modules_scheduler_tracing_js-node_modules-5ac277"]
];
// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

var checkDeferredModules = x => {};

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime, executeModules] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0, resolves = [];
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			resolves.push(installedChunks[chunkId][0]);
		}
		installedChunks[chunkId] = 0;
	}
	for(moduleId in moreModules) {
		if(__webpack_require__.o(moreModules, moduleId)) {
			__webpack_require__.m[moduleId] = moreModules[moduleId];
		}
	}
	if(runtime) runtime(__webpack_require__);
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	while(resolves.length) {
		resolves.shift()();
	}

	// add entry modules from loaded chunk to deferred list
	if(executeModules) deferredModules.push.apply(deferredModules, executeModules);

	// run deferred modules when all chunks ready
	return checkDeferredModules();
}

var chunkLoadingGlobal = self["webpackChunkrnStarter"] = self["webpackChunkrnStarter"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));

function checkDeferredModulesImpl() {
	var result;
	for(var i = 0; i < deferredModules.length; i++) {
		var deferredModule = deferredModules[i];
		var fulfilled = true;
		for(var j = 1; j < deferredModule.length; j++) {
			var depId = deferredModule[j];
			if(installedChunks[depId] !== 0) fulfilled = false;
		}
		if(fulfilled) {
			deferredModules.splice(i--, 1);
			result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
		}
	}
	if(deferredModules.length === 0) {
		__webpack_require__.x();
		__webpack_require__.x = x => {};
	}
	return result;
}
var startup = __webpack_require__.x;
__webpack_require__.x = () => {
	// reset startup function so it can be called again when more startup code is added
	__webpack_require__.x = startup || (x => {});
	return (checkDeferredModules = checkDeferredModulesImpl)();
};